<div>{{ APP_VERSION }}</div>
